import { requst } from '../config'

// 新增
export const AddCompensationDataApi = params => {
    const url = `/business/compensation`
    return requst.post(url, { ...params })
}

/* 修改 */
export const putCompensationDataApi = params => {
    const url = `/business/compensation`
    return requst.put(url, params)
}

// 删除
export const DeleteCompensationDataApi = id => {
    const url = `/business/compensation/${id}`
    return requst.delete(url)
}

// 获取报酬列表
export const getCompensationDataApi = projectId => {
    const url = `/business/compensation/list/${projectId}`
    return requst.get(url)
}

// 批量保存营收用户自定义输入数据
export const postCompensationsaveBatchApi = params => {
    const url = `/business/compensation/item/saveBatch`
    return requst.post(url, params)
}

// 获取营收用户自定义输入数据
export const getCompensationsaveBatchApi = id => {
    const url = `/business/compensation/item/list?busyCompensationId=${id}`
    return requst.get(url)
}

// 获取营收用户 月份 自定义输入数据
export const postCompensationDateDetailApi = params => {
    const url = `/business/dashboard/compensationDateDetail`
    return requst.post(url,params)
}